module.exports = __webpack_public_path__ + "static/media/mama-burger-2023-dt-fr.7cf7d17e.jpg";